import {IContactPerson} from '../../shared/types/person.types';
import qs from 'qs';

import axiosInstance from '../protected';

import {getCompaniesUrl} from '../api.config';

import {ICompany, ICompanyPostBody, ICompanySpec} from '../../shared/types/company.types';
import {IPageable, IPageableDto} from '../../shared/types/pageable.types';
import {CompanyDto} from '../../shared/types/api-v2.types';

export const CompanyService = {
  async getAll(
    attr: {
      pageable?: IPageable;
      spec?: ICompanySpec;
    } = {},
  ) {
    return await axiosInstance.get<IPageableDto<ICompany>>(getCompaniesUrl(), {
      params: {
        ...attr.pageable,
        ...attr.spec,
      },
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, {arrayFormat: 'repeat'});
        },
      },
    });
  },

  async getById(id: string) {
    return await axiosInstance.post<ICompany>(getCompaniesUrl(`/findByIDs`), [id]);
  },

  async update(data: ICompany) {
    return await axiosInstance.put<ICompany>(getCompaniesUrl(), data);
  },

  async delete(id: string) {
    await axiosInstance.delete(getCompaniesUrl(`/`), {
      data: [id],
    });
  },

  async deleteAFew(IDs: string[]) {
    return await axiosInstance.delete<string[]>(getCompaniesUrl(), {
      params: {
        id: IDs,
      },
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, {arrayFormat: 'repeat'});
        },
      },
    });
  },

  async create(data: ICompanyPostBody) {
    return await axiosInstance.post<ICompany>(getCompaniesUrl(), data);
  },

  async findByIDs(IDs: string[]) {
    return await axiosInstance.post<ICompany[]>(getCompaniesUrl(`/findByIDs`), IDs);
  },

  async getContactPersons(id: string) {
    return await axiosInstance.get<IContactPerson[]>(getCompaniesUrl(`/${id}/persons`));
  },

  findByIDsV2(idArray: string[]) {
    return axiosInstance.post<CompanyDto[]>(getCompaniesUrl(`/findByIDs`), idArray);
  },
};
